import { usePaths } from 'src/routes/paths';

export const useProductPathname = (productData) => {
  const paths = usePaths();

  const formattedName = productData?.name?.english.replace(/ /g, '-');
  const productUrl = productData?.url;

  const productRoute = `${paths.public.productView(productUrl || formattedName)}`;

  return {
    productRoute,
  };
};
